import { useState, useRef, useEffect, useMemo } from 'react'
import { inject, observer } from 'mobx-react';
import { Input, Card, Button, ModalAlert, Select, FormLoading } from '../../components'
import { CommonService, AlertCostService } from "../../services";
import DataGrid, { SearchPanel, Scrolling, Item, Paging, Pager, Column, Toolbar, HeaderFilter } from 'devextreme-react/data-grid';
import { RefreshIcon, SearchIcon } from '@heroicons/react/outline';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment'
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next'

const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';
let firstRender = false
const Alert = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['notify', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [masterOptions, setMasterOptions] = useState({
    event_name: [],
    vehicle: []
  })
  const [loading, setLoading]: any = useState(false)
  const [dataSource, setDataSource]: any = useState([])
  const [filterCurrent, setFilterCurrent]: any = useState({})
  const [filter, setFilter]: any = useState({
    sdate: moment().format("YYYY-MM-DD"),
    edate: moment().format("YYYY-MM-DD"),
    vid: "",
    event_id: ""
  })
  const [optionAlert, setOptionAlert]: any = useState({
    show: false,
    action: {
      id: "",
      name: ""
    },
    type: "success",
    title: "",
    description: {
      visible: false,
      type: "",
      content: "",
      contentLists: []
    }
  })

  const gridRef: any = useRef(null);
  let columns = [
    {
      dataField: 'no',
      caption: t('no'),
      width: 90,
      alignment: "center"
    },
    {
      dataField: 'alert_date',
      caption: t('notifications_date')
    },
    {
      dataField: 'licenseplate',
      caption: t('license_plate')
    },
    {
      dataField: 'service_name',
      caption: t('driver')
    },
    {
      dataField: 'event_name',
      caption: t('notifications_type'),
      allowFiltering: true
    },
    {
      dataField: 'description',
      caption: t('details')
    }
  ]

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "event_name,vehicle")
        .then((res: any) => {
          let event_name = res.result.event_name.map((item) => ({ label: item.event_name, value: item.event_id }))
          let vehicle = res.result.vehicle.map((item) => ({ label: item.licenseplate, value: item.vehicle_id }))
          setMasterOptions({
            ...masterOptions,
            event_name,
            vehicle
          })
        })
        .catch((err) => {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, content: `Load master data : ${err}` }
          })
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  const searchAlert = (isReloadCurrent = false) => {
    setLoading(true)
    setFilterCurrent(filter)
    let data = isReloadCurrent ? filterCurrent : filter
    AlertCostService.getAlert(auth, data)
      .then((res: any) => {
        let { code, message, result, sys_message } = res
        if (code === 200) {
          setDataSource(result)
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
        }
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "ผิดพลาด",
          description: { visible: true, type: "text", content: `${err}` }
        })
      })
  }
  //#endregion

  let dateValue: any = [dayjs(filter.sdate, dateFormat), dayjs(filter.edate, dateFormat)]
  const isMobile = useMemo(() => window.innerWidth <= 768, []);
  return (
    <div className="space-y-3 p-4">
      <Card title={t('notifications')}>
        <div className="mt-5 md:col-span-2 md:mt-0">
          <FormLoading loading={loading} >
            <div className="flex flex-col lg:flex-row mb-2 gap-2">

              <div className="flex flex-col lg:flex-row lg:items-center gap-2">

                {/* ประเภทแจ้งเตือน */}
                <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                  <label className="text-sm font-medium text-gray-700 sm:mt-3 sm:mr-2 text-start whitespace-nowrap">
                    {t('notifications_type')} :
                  </label>
                  <div className="mt-1 sm:mt-0">
                    <Select
                      showSearch={true}
                      allowClear={true}
                      defaultValue={filter.event_id}
                      placeholder={t('notifications_type')}
                      width={isMobile ? '100%' : 170}
                      options={masterOptions.event_name}
                      onChange={(value) => setFilter({ ...filter, event_id: value })}
                    />
                  </div>
                </div>

                {/* วันที่ */}
                <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                  <label className="text-sm font-medium text-gray-700 sm:mt-3 sm:mr-2 text-start whitespace-nowrap">
                    {t('date')} :
                  </label>
                  <div className="mt-1 sm:mt-0">
                    <RangePicker
                      allowClear={false}
                      defaultValue={dateValue}
                      className="w-full sm:w-auto"
                      onChange={(d: any) => {
                        if (d) {
                          setFilter({
                            ...filter,
                            sdate: d[0].format("YYYY-MM-DD"),
                            edate: d[1].format("YYYY-MM-DD")
                          })
                        }
                        else {
                          setFilter({
                            ...filter,
                            sdate: "",
                            edate: ""
                          })
                        }
                      }}
                    />
                  </div>
                </div>

                {/* ทะเบียนรถ */}
                <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                  <label className="text-sm font-medium text-gray-700 sm:mt-3 sm:mr-2 text-start whitespace-nowrap">
                    {t('license_plate')} :
                  </label>
                  <div className="mt-1 sm:mt-0">
                    <Select
                      allowClear={true}
                      showSearch={true}
                      defaultValue={filter.vid}
                      placeholder={t('license_plate')}
                      width={isMobile ? '100%' : 150}
                      options={masterOptions.vehicle}
                      onChange={(value) => setFilter({ ...filter, vid: value })}
                    />
                  </div>
                </div>

                {/* ปุ่มค้นหา */}
                <div className="flex flex-col sm:flex-row sm:items-center">
                  <label className="text-sm font-medium text-gray-700 sm:mt-3 sm:mr-2 text-start"></label>
                  <div className="mt-1 sm:mt-0 pt-1">
                    <Button
                      text={t('search')}
                      icon={<SearchIcon />}
                      size="md"
                      type="white"
                      title={t('search')}
                      onClick={() => {
                        if (!loading) {
                          searchAlert()
                        }
                      }}
                    />
                  </div>
                </div>

              </div>
            </div>


            <DataGrid
              ref={(ref) => gridRef.current = ref}
              dataSource={dataSource}
              keyExpr={'id'}
              showBorders={true}
              columnAutoWidth={true}
              hoverStateEnabled={true}
            >
              <Scrolling columnRenderingMode="virtual" />
              <SearchPanel visible={false} />
              <Paging defaultPageSize={10} />
              <Pager
                showInfo={true}
                showPageSizeSelector={true}
                allowedPageSizes={[10, 20, 50]}
              />
              <HeaderFilter visible={true} />
              {
                columns.map((column) => <Column
                  key={column.dataField}
                  width={column.width}
                  allowFiltering={column.allowFiltering || false}
                  dataField={column.dataField}
                  caption={column.caption}
                  alignment={column.alignment}
                />)
              }
              <Toolbar visible={false}>
                <Item location="after">
                  <button
                    type="button"
                    className="-mb-1 inline-flex items-center px-1.5 py-1.5 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                    title="Refresh"
                    onClick={() => { }}
                  >
                    <RefreshIcon className="w-4 h-4" />
                  </button>
                </Item>

                <Item location="after">
                  <button
                    type="button"
                    className="-mb-1 inline-flex items-center px-1.5 py-1.5 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                    title="Export"
                  >
                    <img className="h-4 w-4" src="/Images/excel.png" />
                  </button>
                </Item>

                <Item location="after">
                  <Input
                    icon={<SearchIcon className="w-5 h-5 text-gray-500" />}
                    placeholder={t('common:search')}
                    onChange={(e) => gridRef.current.instance.searchByText(e.target.value)}
                  />
                </Item>
              </Toolbar>
            </DataGrid>
          </FormLoading>
        </div>
      </Card >

      <ModalAlert
        {...optionAlert}
        onOk={() => {
          setOptionAlert({ ...optionAlert, show: false })
        }}
        onCancel={() => {
          setOptionAlert({ ...optionAlert, show: false })
        }}
      />
    </div>
  )
}))

export default Alert